import { createSelector } from 'reselect';
const departments = (state) => state.screens.employer.occHealthDepartmentsData;
const requirements = (state) => state.screens.employer.occHealthRequirementsData;
const vaLocations = (state) => state.screens.employer.medRecruiterLocationsData;
const vaRegions = (state) => state.entities.metaData.vaRegions;

export const getDepartmentsWithReqNames = createSelector(
  [departments, requirements],
  (departments, requirements) => {
    // attach requirement names to departments list
    const deptsWithReqs = Object.values(departments).map((dept) => {
      const reqs = Object.values(requirements).filter((req) =>
        dept.requirements.map((r) => r.master_requirement_id).includes(req.master_requirement_id)
      );
      const requirementNames = reqs.map((req) => req.name).join(', ');
      const updatedDept = { ...dept, requirementNames };
      return updatedDept;
    });
    return deptsWithReqs;
  }
);

export const vaLocationsWithRegionName = createSelector(
  [vaLocations, vaRegions],
  (vaLocations, vaRegions) => {
    const locationsWithRegionName = Object.values(vaLocations).map((loc) => {
      const region = Object.values(vaRegions).find((r) => r.id === loc.va_region);
      const updatedLoc = { ...loc, regionName: region?.name };
      return updatedLoc;
    });
    return locationsWithRegionName;
  }
);

export const vaRegionNameAndCount = createSelector(
  [vaLocations, vaRegions],
  (vaLocations, vaRegions) => {
    const regionCounts = Object.values(vaLocations).reduce((result, loc) => {
      const regionId = loc.va_region;
      const count = result[regionId] ? result[regionId] + 1 : 1;
      return { ...result, [regionId]: count };
    }, {});

    const regionNamesAndCounts = Object.values(vaRegions).map((r) => {
      const count = regionCounts[r.id] || 0;
      return { id: r.id, name: r.name, count };
    });

    return regionNamesAndCounts;
  }
);
